import { CodeListModifiedComments, CodeListModifiedFactor } from "app/area/indicator-factors/list/types-store";

export const getModifiedItemsLength = (factors: CodeListModifiedFactor[], comments: CodeListModifiedComments[]) =>
  [...comments, ...factors].reduce((acc, item) => {
    if (!acc.some(obj => obj.id === item.id)) {
      acc.push(item);
    }
    return acc;
  }, []).length;
